<template>
  <div :style="styleObj" class="model-bd">
    <div class="cont-comp-loading" v-if="loading">
      <a-spin :spinning="loading"></a-spin>
    </div>
    <div class="widget-time" v-show="dateRang && dateRang.length > 0">
			<TagDateRange size="small" v-model="dateRang"  @change="onChange"></TagDateRange>
    </div>
    <v-chart :options="options" autoresize ref="chart" v-if="refresh"/>
  </div>
</template>

<script>
import moment from 'moment';
import TagDateRange from "@/components/TagDateRange";
import { ChartDefaultColor, ChartOptionsColor } from "@/utils/enum"
import { barOrLineChartFn } from "@/utils/modelMethods";

export default {
  name: "WidgetLinechart",
  components: {},
  props: {
    value: Object,
    ispreview: Boolean,
  },
  components: {
    TagDateRange
  },
  data() {
    return {
      options: {
        grid: {},
        color: [],
        title: {
          text: "",
          textStyle: {
            color: "#fff",
          },
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c}%",
        },
        legend: {
          textStyle: {
            color: "#fff",
          },
        },
        xAxis: {
          type: "category",
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
          axisLabel: {
            show: true,
            textStyle: {
              color: "#fff",
            },
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            show: true,
            textStyle: {
              color: "#fff",
            },
          },
        },
        series: [
          {
            data: [],
            avoidLabelOverlap: true,
            type: "line",
          },
        ],
      },
      optionsStyle: {}, // 样式
      optionsData: {}, // 数据
      optionsSetup: {},
      // 时间组件
      dateRang: [],
      loading: false,
      timeSelector: "",
      flag: false,
      refresh: false
    };
  },
  inject: ["getDashboardDynamicData", "getFilterCondition"],
  computed: {
    dashbordData() {
      return this.getDashboardDynamicData()?.contextData || {}
    },
    styleObj() {
      return {
        position: this.ispreview ? "absolute" : "static",
        width: this.optionsStyle.width + "px",
        height: this.optionsStyle.height + "px",
        left: this.optionsStyle.left + "px",
        top: this.optionsStyle.top + "px",
        background: this.optionsSetup.background,
      };
    },
  },
  watch: {
    value: {
      handler(val) {
        console.log(val, 'val-------')
        this.optionsStyle = val.position;
        this.optionsData = val.data;
        this.optionsSetup = val.setup;
        if(this.ispreview && this.isContCompDate(this.optionsData)) {
          // console.log(222)
        }else {
          this.editorOptions();
          this.setOptionsData();
          this.editorDataSet();
        }
      },
      deep: true,
    },
  },
  created() {
    this.optionsStyle = this.value.position;
    this.optionsData = this.value.data;
    this.optionsSetup = this.value.setup;
    this.editorOptions();
    this.setOptionsData();
  },
  methods: {
    refreshChart() {
      this.refresh = false
      this.$nextTick(() => {
        this.refresh = true
      })
    },
    disabledDate(current) {
      return current && current > moment().endOf('day');
    },
    filterSearch() {
      this.getEchartData(this.optionsData.dynamicData, this.optionsSetup);
    },
    onChange(val, timeSelector) {
      if(this.ispreview){
        const optionsSetup = this.optionsSetup;
        const optionsData = this.optionsData;
        const dataSet = this.optionsData.dynamicData.contextData;
        dataSet.dateRang.from = val[0];
        dataSet.dateRang.to = val[1];
        dataSet.dateRang.timeSelector = timeSelector;
        this.getEchartData(optionsData.dynamicData, optionsSetup);
      }
    },
    editorDataSet(){
      // 获取数据的配置项；
      const dataSet = this.optionsData.dynamicData.contextData;
      // 设置日期响应
      if(!!dataSet && dataSet.dateRang.from && dataSet.dateRang.to){
        let dateRang = [];
        dateRang[0] = dataSet.dateRang.from;
        dateRang[1] = dataSet.dateRang.to;
        this.$set(this.dateRang, 0, dateRang[0])
        this.$set(this.dateRang, 1, dateRang[1])
        this.timeSelector = dataSet.dateRang.timeSelector
      }else {
        this.dateRang = [];
        this.timeSelector = ''
      }
    },
    previewInit(data) {
      console.log(data, "tableData");
      if(this.isContCompDate(this.optionsData)){
        // const that  = this;
        if(!this.flag){
          this.setBarFromResponse(data)
          this.flag = true;
        }
      }else {
        this.setBarFromResponse(data)
      }
    },
    setBarFromResponse(res) {
      // const optionsSetup = this.optionsSetup;
      const params = this.optionsData.dynamicData.params;
      const dataParams = this.optionsData.dynamicData.contextData;
      const combineData = barOrLineChartFn(params.widgetType, dataParams, res);
      new Promise((resolve, reject) => {
        resolve(combineData)
      }).then(response => {
        this.renderingFn(response);
      })
    },
    // 修改图标options属性
    editorOptions() {
      this.options = {
        ...this.options,
        title: this.setOptionsTitle(),
        xAxis: {
          ...this.options.xAxis,
          ...this.setOptionsX()
        },
        tooltip: this.setOptionsTooltip(),
        grid: this.setOptionsMargin(),
        legend: {
          ...this.options.legend,
          ...this.setOptionsLegend()
        },
        color: this.setOptionsColor()
      }
      this.setOptionsY();
      this.setOptionsTop();
      this.refreshChart()
    },
    // 标题修改
    setOptionsTitle() {
      const optionsSetup = this.optionsSetup;
      return {
        text: optionsSetup.titleText,
        show: true,
        left: optionsSetup.textAlign || 'left',
        textStyle: {
          color: optionsSetup.textColor || "#13234C",
          fontSize: optionsSetup.textFontSize || 16,
          fontWeight: optionsSetup.textFontWeight || 400,
        },
        subtext: optionsSetup.subText,
        subtextStyle: {
          color: optionsSetup.subTextColor,
          fontWeight: optionsSetup.subTextFontWeight,
          fontSize: optionsSetup.subTextFontSize,
        },
        padding: [16, 24, 8, 24]
      };
    },
    // X轴设置
    setOptionsX() {
      const optionsSetup = this.optionsSetup;
      return {
        type: "category",
        show: optionsSetup.hideX, // 坐标轴是否显示
        name: optionsSetup.xName, // 坐标轴名称
        nameTextStyle: {
          color: optionsSetup.nameColorX,
          fontSize: optionsSetup.nameFontSizeX,
        },
        nameRotate: optionsSetup.textAngle, // 文字角度
        inverse: optionsSetup.reversalX, // 轴反转
        axisLabel: {
          show: true,
          interval: optionsSetup.textInterval, // 文字间隔
          rotate: optionsSetup.textAngle, // 文字角度
          textStyle: {
            color: optionsSetup.Xcolor, // x轴 坐标文字颜色
            fontSize: optionsSetup.fontSizeX,
          },
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: optionsSetup.lineColorX,
          },
        },
        axisPointer: {
          show: true,
          lineStyle: {
            color: 'transparent',
          },
        },
        splitLine: {
          show: optionsSetup.isShowSplitLineX,
          type: 'dotted',
          lineStyle: {
            color: optionsSetup.splitLineColorX,
          },
        },
      };
    },
    // Y轴设置
    setOptionsY(multipleY = false) {
      const optionsSetup = this.optionsSetup;
      let yAxis = [];
      let initYAxis = {
        type: "value",
        scale: optionsSetup.scale,
        splitNumber: optionsSetup.splitNumber, // 均分
        min: optionsSetup.min || undefined, // 最小值
        minInterval: optionsSetup.minInterval || undefined, // 最小间隔
        show: optionsSetup.isShowY, // 坐标轴是否显示
        name: optionsSetup.textNameY, // 坐标轴名称
        position: 'left',
        axisTick: {                   //坐标轴 刻度
          show: true,                 //是否显示
        },
        alignTicks: true,
        nameTextStyle: {
          // 别名
          color: optionsSetup.nameColorY,
          fontSize: optionsSetup.namefontSizeY,
        },
        inverse: optionsSetup.reversalY, // 轴反转
        axisLabel: {
          show: true,
          rotate: optionsSetup.ytextAngle, // 文字角度
          textStyle: {
            color: optionsSetup.colorY, // y轴 坐标文字颜色
            fontSize: optionsSetup.fontSizeY,
          },
          formatter: '{value}'
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: optionsSetup.lineColorY,
          },
        },
        splitLine: {
          show: optionsSetup.isShowSplitLineY,
          lineStyle: {
            color: optionsSetup.splitLineColorY,
          },
        },
        data: this.options.series[0]?.data || []
      };
      // 对于设置了多y轴的配置，需要重新组装y轴配置
      if(multipleY){
        let series = this.options.series;
        const dataParams = this.optionsData.dynamicData.contextData;
        const secondaryAxis = dataParams.secondaryAxis
        console.log(this.options, series, dataParams, 'secondaryAxis');

        let rightIndex = -1
        series.forEach((item, index) => {
          let obj = this.$deepclone(initYAxis);
          // obj.name = item.name;
          if(secondaryAxis === item.data[0].field){
            obj.position = 'right';
            rightIndex = index
          }
          yAxis.push(obj);
        })
        //发现一个bug, right如果在第二个之后则不显示
        //如果在第二个之后, 移到最前面
        if(rightIndex>1){
          series.splice(0,0,series.splice(rightIndex,1)[0])
          yAxis.splice(0,0,yAxis.splice(rightIndex,1)[0])
        }
      }else {
        yAxis = initYAxis
      }
      console.log(yAxis, 'yAxis')
      this.options.yAxis = yAxis;
    },
    // 折线设置
    setOptionsTop() {
      const optionsSetup = this.optionsSetup;
      const series = this.options.series;
      for (const key in series) {
        if (series[key].type == "line") {
          series[key].showSymbol = optionsSetup.markPoint;
          series[key].symbolSize = optionsSetup.pointSize;
          series[key].smooth = optionsSetup.smoothCurve;
          if (optionsSetup.area) {
            series[key].areaStyle = {
              opacity: optionsSetup.areaThickness / 100,
            };
          } else {
            series[key].areaStyle = {
              opacity: 0,
            };
          }

          series[key].lineStyle = {
            width: optionsSetup.lineWidth,
          };
          series[key].label = {
            show: optionsSetup.isShow,
            position: "top",
            distance: 10,
            fontSize: optionsSetup.fontSize,
            color: optionsSetup.subTextColor,
            fontWeight: optionsSetup.fontWeight,
          };
        }
      }
      this.options.series = series;
    },
    // tooltip 设置
    setOptionsTooltip() {
      const optionsSetup = this.optionsSetup;
      return {
        // triggerOn: 'none',
        trigger: "axis",
        backgroundColor: 'rgba(45, 52, 70, 0.96)',
        show: true,
        extraCssText:'text-align: left;',
        textStyle: {
          color: optionsSetup.lineColor || '#FFFFFF',
          fontSize: '14px',
        },
        formatter: (params) => this.$formatChartTooltip(params)
      }
    },
    // 边距设置
    setOptionsMargin() {
      const optionsSetup = this.optionsSetup;
      return {
        left: optionsSetup.marginLeft || 24,
        right: optionsSetup.marginRight || 24,
        bottom: optionsSetup.marginBottom || 14,
        top: optionsSetup.marginTop || 106,
        containLabel: true,
      };
    },
    // 图例操作 legend
    setOptionsLegend() {
      const optionsSetup = this.optionsSetup;
      return {
        show: optionsSetup.isShowLegend  || true,
        left: optionsSetup.lateralPosition || "right",
        right: optionsSetup.lateralPosition || 24,
        top: optionsSetup.longitudinalPosition || 40,
        bottom: optionsSetup.longitudinalPosition || "top",
        orient: optionsSetup.layoutFront || "horizontal",
        textStyle: {
          color: optionsSetup.lengedColor  || "#677392",
          fontSize: optionsSetup.fontSize,
        },
        padding: [14, 24, 14, 0 ],
        itemWidth: optionsSetup.lengedWidth || 12
      }
    },
    // 图例名称设置
    setOptionsLegendName(name) {
      // debugger;
      const optionsSetup = this.optionsSetup;
      const series = this.options.series;
      const legendName = optionsSetup.legendName;
      // 图例没有手动写则显示原值，写了则显示新值
      if (null == legendName || legendName == "") {
        for (let i = 0; i < name.length; i++) {
          series[i].name = name[i];
        }
        this.options.legend["data"] = name;
      } else {
        const arr = legendName.split("|");
        for (let i = 0; i < arr.length; i++) {
          series[i].name = arr[i];
        }
        this.options.legend["data"] = arr;
      }
    },
    // 图例颜色修改
    setOptionsColor() {
      const isCompare = this.optionsData.dynamicData.contextData && this.optionsData.dynamicData.contextData.calc ? this.optionsData.dynamicData.contextData.calc.compare : false;
      const defaultColor = isCompare ? this.$enum.ChartCompareColor :  this.$enum.ChartDefaultColor;
      const customColor = this.optionsSetup.customColor || defaultColor;
      if(!customColor) {
        return isCompare ? this.$enum.ChartCompareOptionsColor : this.$enum.ChartOptionsColor
      } else {
        const arrColor = [];
        for (let i = 0; i < customColor.length; i++) {
          arrColor.push(customColor[i].color);
        }
        return arrColor
      }
      // this.options.color = arrColor;
      // this.options = Object.assign({}, this.options);
    },
    // 处理数据
    setOptionsData() {
      const optionsSetup = this.optionsSetup;
      const optionsData = this.optionsData; // 数据类型 静态 or 动态
      console.log(optionsData, 'optionsData');
        if(optionsData.dataType == "staticData"){
          this.staticDataFn(optionsData.staticData);
        }else if(optionsData.dataType == "dynamicData"){
          let oneTime = this.$once(this.staticDataFn);
        oneTime(optionsData.staticData);
          // 如果是新的数据，则还是利用旧数据进行渲染；
          if(optionsData.dynamicData && optionsData.dynamicData.contextData){
            this.dynamicDataFn(optionsData.dynamicData, optionsData.refreshTime,optionsSetup)
          }
        }
    },
    staticDataFn(val) {
      const series = this.options.series;
      let axis = [];
      let data = [];
      for (const i in val) {
        axis[i] = val[i].axis;
        data[i] = val[i].data;
      }
      // x轴
      this.options.xAxis.data = axis;
      // series
      for (const i in series) {
        if (series[i].type == "line") {
          series[i].data = data;
        }
      }
      const legendName = [];
      legendName.push("销售量");
      this.options.legend["data"] = legendName;
      this.setOptionsLegendName(legendName);
    },
    dynamicDataFn(val, refreshTime) {
      // 前端定义的相关数据
      console.log(val, 'dynamicDataFn-val');
      if (this.ispreview) {
        this.editorDataSet();
      } else {
        if (!val  || !val.chartProperties) return;
        this.getEchartData(val);
      }
    },
    getEchartData(val) {
      this.loading = true;
      try {
        const data = this.queryEchartsData(val.contextData,val.params, val.chartProperties);
        data.then((res) => {
          this.loading = false;
          console.log(res, 'Echarts')
          this.renderingFn(res);
        }).catch(err => {
          this.loading = false;
        });
      } catch (error) {
        console.log(error, 'getEchartData-error')
        this.loading = false;
      }
      
      //依据数据源后端返回数据
      // this.renderingFn(val);
    },
    renderingFn(val) {
      const optionsSetup = this.optionsSetup;
      const optionsData = this.optionsData;
      // console.log(val, 'linechart-renderingFn-val');
      // x轴
      this.options.xAxis.data = val.xAxis;
      // series
      // 对于 轴为空或者 数据为空的情况，重新配置为静态数据
      if(val.xAxis.length === 0 || val.series.length === 0) {
        this.staticDataFn(optionsData.staticData);
        return;
      }
      const series = this.options.series;
      const legendName = [];
      const newSeries = []
      const that  = this;
      if(series && series.length > 0 && val.series) {
        const valLen = val.series.length
        val.series.forEach((item,index) => {
          newSeries[index] = {  ...series[0], name: '', data: [], yAxisIndex: item.yAxisIndex}
          if (newSeries[index].type == "line") {
            newSeries[index].name = valLen > 0 ?  val.series[index].name : null;
            newSeries[index].data = valLen > 0 ? val.series[index].data.map((v,i) => ({
              ...v,
              yName: val.xAxis[i]
            })) : [];
            newSeries[index].itemStyle = {
              normal: { 
                label: {
                  show: optionsSetup.isShow,
                  position: "top",
                  distance: 10,
                  fontSize: optionsSetup.fontSize,
                  color: optionsSetup.subTextColor,
                  fontWeight: optionsSetup.fontWeight,
                  formatter: function(params) {
                    const value = params.value;
                    let formatValue = that.$getThousandths(value)
                    return formatValue;
                  }
                }
              }
            }
            legendName.push(newSeries[index].name);
          }
        })
        // for (const i in series) {
      //   if (series[i].type == "line") {
      //     series[i].data = val.series[i].data;
      //     series[i].name = val.series[i].name;
      //   }
      //   legendName.push(val.series[i].name);
      // }
      }
      
      // many series
      // const series = this.$deepclone(this.options.series);
      // const series0 = series[0]; 
      // series0.name = "";
      // series0.data = [];
      // const newSeries = []
      // val.series.forEach((item, index) => {
      //   newSeries.push(this.$deepclone(series0));
      //   if (newSeries[index].type == "line") {
      //     newSeries[index].data = item.data;
      //     newSeries[index].name = item.name;
      //   }
      //   legendName.push(item.name);
      // });
      console.log(newSeries, 'newSeries')
      this.options.series = newSeries;
      this.options.legend['data'] = legendName;
      this.setOptionsLegendName(legendName);
      // 依据数据重新分配多y轴
      this.setOptionsY(true);
      this.refreshChart()
    },
  },
};
</script>

<style scoped lang="less">
.echarts {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

</style>
